import { Component, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GameService, TicketService, FGBTranslationLoader, FGBMissingTranslationHandler } from '@fgb/core';
import * as _moment from 'moment';
import { map } from 'rxjs/operators';
import { TicketTransferGamePanelModule } from '@fgb/portal-component-library/src/lib/tickettransfer/ticket-transfer-game-panel';
import { DirectivesModule } from '@fgb/portal-component-library/src/lib/directives';
import { TranslateModule, TranslateLoader, MissingTranslationHandler } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@fgb/core';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from '@fgb/portal-component-library/src/lib/tickettransfer/ticket-transfer-game-panel';
import * as ɵngcc4 from '@ngx-translate/core';

function GamesListWithTicketsComponent_ng_container_0_ng_container_1_h4_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "h4", 5);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, "cl.game.list.with.tickets.title"));
} }
function GamesListWithTicketsComponent_ng_container_0_ng_container_1_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 6);
    ɵngcc0.ɵɵelement(1, "fgbcl-ticket-transfer-game-panel", 7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const event_r7 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("customerTicketSummary", event_r7);
} }
function GamesListWithTicketsComponent_ng_container_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, GamesListWithTicketsComponent_ng_container_0_ng_container_1_h4_1_Template, 3, 3, "h4", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵtemplate(3, GamesListWithTicketsComponent_ng_container_0_ng_container_1_div_3_Template, 2, 1, "div", 4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const events_r3 = ɵngcc0.ɵɵnextContext().ngIf;
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.showPastGamesOnly);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", events_r3);
} }
function GamesListWithTicketsComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, GamesListWithTicketsComponent_ng_container_0_ng_container_1_Template, 4, 2, "ng-container", 0);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const events_r3 = ctx.ngIf;
    ɵngcc0.ɵɵnextContext();
    const _r1 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", events_r3.length > 0)("ngIfElse", _r1);
} }
function GamesListWithTicketsComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵelementStart(1, "p");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 1, "cl.game.list.with.tickets.no.games.text"));
} }
const moment = _moment;
class GamesListWithTicketsComponent {
    constructor(gameService, ticketService) {
        this.gameService = gameService;
        this.ticketService = ticketService;
        this.showPastGamesOnly = false;
    }
    ngOnInit() {
        this.ticketService.resetSelectedTickets();
        this.games$ = this.gameService.fetchGamesWithTickets().pipe(map((games) => {
            if (games == undefined) {
                return undefined;
            }
            if (this.showPastGamesOnly) {
                games = games.filter((game) => moment.utc(game.Date).endOf('day').isBefore(moment.utc()));
                return games.sort((a, b) => {
                    return moment.utc(b.Date).diff(moment.utc(a.Date));
                });
            }
            else {
                games = games.filter((game) => moment.utc(game.Date).endOf('day').isAfter(moment.utc()));
                return games.sort((a, b) => {
                    return moment.utc(a.Date).diff(moment.utc(b.Date));
                });
            }
        }));
    }
}
GamesListWithTicketsComponent.ɵfac = function GamesListWithTicketsComponent_Factory(t) { return new (t || GamesListWithTicketsComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.GameService), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.TicketService)); };
GamesListWithTicketsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: GamesListWithTicketsComponent, selectors: [["fgbcl-games-list-with-tickets"]], inputs: { showPastGamesOnly: "showPastGamesOnly" }, decls: 4, vars: 4, consts: [[4, "ngIf", "ngIfElse"], ["noEventsFound", ""], ["class", "past-games-title text-primary", 4, "ngIf"], [1, "row"], ["class", "col-lg-4", 4, "ngFor", "ngForOf"], [1, "past-games-title", "text-primary"], [1, "col-lg-4"], [3, "customerTicketSummary"], [1, "no-events"]], template: function GamesListWithTicketsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, GamesListWithTicketsComponent_ng_container_0_Template, 2, 2, "ng-container", 0);
        ɵngcc0.ɵɵpipe(1, "async");
        ɵngcc0.ɵɵtemplate(2, GamesListWithTicketsComponent_ng_template_2_Template, 4, 3, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(3);
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(1, 2, ctx.games$))("ngIfElse", _r1);
    } }, directives: [ɵngcc2.NgIf, ɵngcc2.NgForOf, ɵngcc3.TicketTransferGamePanelComponent], pipes: [ɵngcc2.AsyncPipe, ɵngcc4.TranslatePipe], styles: ["h5[_ngcontent-%COMP%]{margin-top:30px}"] });
GamesListWithTicketsComponent.ctorParameters = () => [
    { type: GameService },
    { type: TicketService }
];
GamesListWithTicketsComponent.propDecorators = {
    showPastGamesOnly: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(GamesListWithTicketsComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-games-list-with-tickets',
                template: "<ng-container *ngIf=\"games$ | async as events; else noEventsFound\">\r\n  <ng-container *ngIf=\"events.length > 0; else noEventsFound\">\r\n    <h4 class=\"past-games-title text-primary\" *ngIf=\"showPastGamesOnly\">{{ 'cl.game.list.with.tickets.title' | translate }}</h4>\r\n    <div class=\"row\">\r\n      <div *ngFor=\"let event of events\" class=\"col-lg-4\">\r\n        <fgbcl-ticket-transfer-game-panel [customerTicketSummary]=\"event\"></fgbcl-ticket-transfer-game-panel>\r\n      </div>\r\n    </div>\r\n  </ng-container>\r\n</ng-container>\r\n<ng-template #noEventsFound>\r\n  <div class=\"no-events\">\r\n    <p>{{ 'cl.game.list.with.tickets.no.games.text' | translate }}</p>\r\n  </div>\r\n</ng-template>\r\n",
                styles: ["h5{margin-top:30px}"]
            }]
    }], function () { return [{ type: ɵngcc1.GameService }, { type: ɵngcc1.TicketService }]; }, { showPastGamesOnly: [{
            type: Input
        }] }); })();

class GamesListWithTicketsModule {
}
GamesListWithTicketsModule.ɵfac = function GamesListWithTicketsModule_Factory(t) { return new (t || GamesListWithTicketsModule)(); };
GamesListWithTicketsModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: GamesListWithTicketsModule });
GamesListWithTicketsModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            TicketTransferGamePanelModule,
            DirectivesModule,
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useClass: FGBTranslationLoader,
                    deps: [HttpClient]
                },
                missingTranslationHandler: {
                    provide: MissingTranslationHandler,
                    useClass: FGBMissingTranslationHandler
                }
            }),
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(GamesListWithTicketsModule, { declarations: function () { return [GamesListWithTicketsComponent]; }, imports: function () { return [CommonModule,
        TicketTransferGamePanelModule,
        DirectivesModule, ɵngcc4.TranslateModule]; }, exports: function () { return [GamesListWithTicketsComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(GamesListWithTicketsModule, [{
        type: NgModule,
        args: [{
                declarations: [GamesListWithTicketsComponent],
                imports: [
                    CommonModule,
                    TicketTransferGamePanelModule,
                    DirectivesModule,
                    TranslateModule.forRoot({
                        loader: {
                            provide: TranslateLoader,
                            useClass: FGBTranslationLoader,
                            deps: [HttpClient]
                        },
                        missingTranslationHandler: {
                            provide: MissingTranslationHandler,
                            useClass: FGBMissingTranslationHandler
                        }
                    }),
                ],
                exports: [GamesListWithTicketsComponent]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { GamesListWithTicketsComponent, GamesListWithTicketsModule };

//# sourceMappingURL=fgb-portal-component-library-src-lib-tickettransfer-games-list-with-tickets.js.map